/**
 *   Generated file. Do not edit
 */

import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getClientId: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/mqtt/client-id',
    path: '/1024//52',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putClientId: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/mqtt/client-id',
    path: '/1024//52',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getUsername: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/mqtt/username',
    path: '/1024//53',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putUsername: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/mqtt/username',
    path: '/1024//53',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getBrokerHostname: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/mqtt/broker-hostname',
    path: '/1024//50',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putBrokerHostname: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/mqtt/broker-hostname',
    path: '/1024//50',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getBrokerPort: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/mqtt/broker-port',
    path: '/1024//51',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putBrokerPort: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/mqtt/broker-port',
    path: '/1024//51',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getPassword: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/mqtt/password',
    path: '/1024//54',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putPassword: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/mqtt/password',
    path: '/1024//54',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getRelayNetKey: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/mqtt/relay-net-key',
    path: '/1024//55',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putRelayNetKey: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/mqtt/relay-net-key',
    path: '/1024//55',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  putBrokerCertificate: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/mqtt/broker-certificate',
    append: true,
    path: '/1024//57',
  } as ServiceCallType<Uint8Array, void>,

  getTopicPrefix: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/mqtt/topic-prefix',
    path: '/1024//58',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putTopicPrefix: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/mqtt/topic-prefix',
    path: '/1024//58',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getRequestTopic: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/mqtt/request-topic',
    path: '/1024//58',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putRequestTopic: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/mqtt/request-topic',
    path: '/1024//58',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getResponseTopic: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/mqtt/response-topic',
    path: '/1024//59',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putResponseTopic: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/mqtt/response-topic',
    path: '/1024//59',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,
};
